import React, { useState } from "react"
import { Drawer, theme } from "@omnichannel/ace-b2b-elements"
import { navigate } from "gatsby"
import styled from "styled-components"
// import SwipeableViews from "react-swipeable-views"
import UserInfo from "./userInfo"
import { APP_ID } from "../helpers/constants"
import CommonAccordion from "./commonAccordion"
import DrawerFooterImage from "../images/drawerfooterimage.jpg"
import { isAuthenticated, formatString } from "../utils/utils"
import { ShoppingBag3 } from "@styled-icons/remix-line/ShoppingBag3"
import { ListUl } from "@styled-icons/boxicons-regular/ListUl"
import SwipeableViews from "react-swipeable-views"

const OrdersIcon = styled(ShoppingBag3)`
  color: #333;
  width: 2rem;
  height: 2rem;
  transform: translateY(-0.2rem);
`

const ListIcon = styled(ListUl)`
  color: #333;
  width: 2.2rem;
  height: 2.2rem;
  transform: translateY(-0.1rem);
`

const ParentCategoryContainer = styled.div`
  margin: 0.6rem 0 0 0;
  padding-left: 1.6rem;
`

const User = styled.div`
  // background-color: #c2171d;
  background-image: linear-gradient(to right, #e8171e, #c2171d);
  height: auto;
  padding: 0.8rem 0rem 2rem 0rem;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
`

const InlinedLink = styled.div`
  cursor: pointer;
`

const DrawerItem = styled.div`
  padding: 0.4rem 0.8rem 0.8rem 0rem;
  font-size: 1.8rem;
  text-transform: capitalize;
  font-weight: 500;
  color: #474747;
`

const AccordionItem = styled.div`
  padding: 0.4rem 0.8rem 0.8rem 3rem;
  font-size: 1.6rem;
  text-transform: capitalize;
  font-weight: 400;
  color: #474747;
`
const AceLogoBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 4.8rem;
  margin-right: 0.4rem;
`

const AceLogoImage = styled.img`
  display: block;
  width: 100%;
`

const ImageWrapperBox = styled.div`
  margin-top: ${props => (props.isAuthenticated ? "0" : "3.2rem")};
  width: 100%;
  padding: 2rem 1.2rem 2rem 0.4rem;
`

const ImageBox = styled.img`
  display: block;
  border-radius: 0.2rem;
  width: 100%;
`

const CategoryCommon = styled.div`
  padding: 1.4rem 1.6rem;
  border-bottom: 0.1rem solid #d5cecf;
`

const CategoryHeader = styled(CategoryCommon)`
  font-size: 2.6rem;
  color: #3e3f42;
  line-height: 3.2rem;
  font-weight: 700;
`

const ChildCategoryContainer = styled.div`
  margin: 3rem 0 0 1rem;
`

const ChildItem = styled.div`
  font-size: 1.6rem;
  color: #3e3f42;
  line-height: 3.2rem;
  padding: 0.4rem 0 0rem 2rem;
  cursor: pointer;
  &:last-of-type {
    padding: 0.4rem 0 1rem 2rem;
    border-bottom: 0.1rem solid #d5cecf;
  }
`

const MainCategory = styled.div`
  cursor: pointer;
  color: ${props => (props.fontColor ? props.fontColor : "#3E3F42")};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: #3e3f42;
  font-size: 1.8rem;
  font-weight: 600;
`

const BackButton = styled.div`
  font-size: 1.4rem;
  color: #555;
  line-height: 2rem;
  font-weight: 600;
  cursor: pointer;
  &::before {
    content: "< ";
  }
`

export function HomeDrawer({ categories = [{}], brands = [], onClose, open }) {
  const drawerSize = "80%"
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [children, setChildren] = useState([])
  return (
    <Drawer open={open} onClose={onClose} width={drawerSize}>
      <User>
        <UserInfo drawer={true} closeDrawer={onClose} />
      </User>
      <SwipeableViews index={selectedCategory ? 1 : 0}>
        <ParentCategoryContainer>
          <CommonAccordion
            title={"Categories"}
            content={categories.map((category, index) => {
              return (
                <AccordionItem
                  key={index}
                  onClick={
                    category.children.length > 0
                      ? () => {
                        setSelectedCategory(category.name)
                        setChildren(category.children)
                      }
                      : () => {
                        navigate(`/category/${category.name}`)
                        onClose()
                      }
                  }
                >
                  {formatString(category.name)}
                </AccordionItem>
              )
            })}
            titlePadding={"2rem 1.4rem 1rem 0rem"}
            fontColor={"#474747"}
          />
          <CommonAccordion
            title={"Brands"}
            content={brands.map((brand, index) => {
              return (
                <AccordionItem
                  key={index}
                  onClick={() => {
                    onClose()
                    sessionStorage.removeItem(`${brand.name}::scrollTo`)
                    navigate(`/brand/${brand.name}`)
                  }}
                >
                  {brand.name}
                </AccordionItem>
              )
            })}
            titlePadding={".4rem 1.4rem 1rem 0rem"}
            ontColor={"#474747"}
          />

          <DrawerItem
            style={{
              cursor: "pointer",
              color: theme[APP_ID].redlabel,
              fontWeight: 600,
            }}
            onClick={() => {
              sessionStorage.removeItem("On Sale::scrollTo")
              navigate("/sale")
              onClose()
            }}
          >
            Sale
          </DrawerItem>
          <DrawerItem
            style={{ cursor: "pointer" }}
            onClick={() => {
              sessionStorage.removeItem("What's New::scrollTo")
              navigate("/newarrival")
              onClose()
            }}
          >
            What's New
          </DrawerItem>
          <DrawerItem
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/stores")
              onClose()
            }}
          >
            Store Locator
          </DrawerItem>
          {/* {isAuthenticated() && (
            <>
              <DrawerItem
                style={{ cursor: "pointer" }}
                onClick={() => {
                  navigate("/account/orderhistory")
                  onClose()
                }}
              >
                Orders <OrdersIcon />
              </DrawerItem>
              <DrawerItem
                style={{ cursor: "pointer" }}
                onClick={() => {
                  navigate("/account/wishlist")
                  onClose()
                }}
              >
                Wishlist <ListIcon />
              </DrawerItem>
            </>
          )} */}
          <ImageWrapperBox isAuthenticated={isAuthenticated()}>
            <ImageBox src={DrawerFooterImage} />
          </ImageWrapperBox>
        </ParentCategoryContainer>
        <ChildCategoryContainer>
          <BackButton
            onClick={e => {
              setSelectedCategory("")
              setChildren([])
            }}
          >
            Back
          </BackButton>
          <CategoryHeader>
            <MainCategory
              onClick={e => {
                if (!e.ctrlKey && !e.metaKey) {
                  sessionStorage.removeItem(`${selectedCategory}::scrollTo`)
                  navigate(`/category/${selectedCategory}`)
                  onClose()
                }
              }}
            >
              {formatString(selectedCategory || "")}
            </MainCategory>
          </CategoryHeader>
          {children.map((category, index) => {
            return (
              <ChildItem
                key={index}
                onClick={e => {
                  if (!e.ctrlKey && !e.metaKey) {
                    sessionStorage.removeItem(`${selectedCategory}/${category.name}::scrollTo`)
                    navigate(`/category/${selectedCategory}/${category.name}`)
                    onClose()
                  }
                }}
              >
                {formatString(category.name)}
              </ChildItem>
            )
          })}
        </ChildCategoryContainer>
      </SwipeableViews>
    </Drawer>
  )
}
